module.exports = __webpack_public_path__ + "static/media/rain.840d6cce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weather/rain.svg
// module id = 2572
// module chunks = 2